import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'logged_out_retailers-footer_links-action_category_click';

/**
 * This pete is used to record all the click on footer links. Not including the customized part.
 */
export function trackLoggedOutRetailersFooterLinksActionCategoryClick(
  link_path: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { link_path },
  });
}
